import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--black)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: 24,
      backgroundImage: 'radial-gradient(ellipse 60% 50% at 80% 50%, rgba(212,169,64,0.07) 0%, transparent 70%)'
    }}>
      <div className="fade-up" style={{ width: '100%', maxWidth: 420 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 36, letterSpacing: 4, color: 'var(--white)', marginBottom: 8 }}>
            THE <span style={{ color: 'var(--gold)' }}>PLAYER</span> OFFICE
          </div>
          <div style={{ fontFamily: 'var(--font-condensed)', fontSize: 12, letterSpacing: 4, textTransform: 'uppercase', color: 'var(--muted)' }}>
            Athlete Business Platform
          </div>
        </div>

        {/* Card */}
        <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderTop: '3px solid var(--gold)', padding: '40px 36px' }}>
          <div style={{ fontFamily: 'var(--font-condensed)', fontSize: 13, fontWeight: 700, letterSpacing: 4, textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 28 }}>
            Sign In
          </div>

          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ fontFamily: 'var(--font-condensed)', fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: 'var(--muted)', display: 'block', marginBottom: 8 }}>
                Email
              </label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)} required
                style={{ width: '100%', padding: '12px 16px', fontSize: 15, background: 'var(--dark)', border: '1px solid var(--border)', color: 'var(--white)' }}
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label style={{ fontFamily: 'var(--font-condensed)', fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: 'var(--muted)', display: 'block', marginBottom: 8 }}>
                Password
              </label>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)} required
                style={{ width: '100%', padding: '12px 16px', fontSize: 15, background: 'var(--dark)', border: '1px solid var(--border)', color: 'var(--white)' }}
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div style={{ background: 'var(--red-d)', border: '1px solid var(--red)', padding: '10px 14px', fontSize: 13, color: '#ff6b6b' }}>
                {error}
              </div>
            )}

            <button
              type="submit" disabled={loading}
              style={{
                background: loading ? 'var(--border)' : 'var(--gold)', color: 'var(--black)',
                border: 'none', padding: '16px', fontFamily: 'var(--font-condensed)',
                fontSize: 14, fontWeight: 800, letterSpacing: 3, textTransform: 'uppercase',
                marginTop: 8, transition: 'background 0.2s', opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? 'Signing In...' : 'Sign In →'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, fontFamily: 'var(--font-condensed)', fontSize: 12, letterSpacing: 2, color: 'var(--muted)' }}>
          theplayeroffice.com
        </div>
      </div>
    </div>
  )
}
